export default "__VITE_ASSET__DyZo7ock__"